<template>
	<div class="payment-methods-wrapper">
		<div class="payment-methods">
			<template v-if="showCategories">
				<!-- sorted payments methods by categories and displayed on the top the category name (only for TH) -->
				<div v-for="(category, key) in pgCategories" :key="key" class="payment-methods__category">
					<div class="payment-methods__category__title">
						{{
							$te(`checkout.pg-categories.${key}`)
								? $t(`checkout.pg-categories.${key}`)
								: category.displayName
						}}
					</div>
					<pgButton
						v-for="pg in category.paymentMethods"
						:key="pg.methodCode"
						:pg-details="pg"
						:loading="loading"
						@click-pg="handleSelectPG"
					/>
				</div>
			</template>

			<template v-else>
				<template v-if="nxCreditList.length > 0">
					<pgButton
						v-for="pg in nxCreditList"
						:key="pg.methodCode"
						:pg-details="pg"
						:loading="loading"
						@click-pg="handleSelectPG"
					/>
				</template>

				<template v-if="nxPrepaidList.length > 0">
					<pgButton
						v-for="pg in nxPrepaidList"
						:key="pg.methodCode"
						:loading.sync="loading"
						:pg-details="pg"
						@click-pg="handleSelectPG"
					/>
				</template>
			</template>
		</div>

		<div v-if="isEUCountry && (nxPrepaidList.length > 0 || nxCreditList.length > 0)" class="payment-message-law">
			{{ $t('checkout.eu-law-message', { buttonName: $t('checkout.complete-purchase') }) }}
		</div>
	</div>
</template>

<script>
import pgButton from '@/components/purchase/pg-button';

export default {
	name: 'PaymentMethodsAll',
	components: {
		pgButton,
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		showCategories: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		nxCreditList() {
			if (this.$store.state.paymentMethodsList && this.$store.state.paymentMethodsList.refundable) {
				const ApplePaySession = window.ApplePaySession;
				// filter out apple payment method if not using apple devicese
				return ApplePaySession && ApplePaySession.supportsVersion(3) && ApplePaySession.canMakePayments()
					? this.$store.state.paymentMethodsList.refundable
					: this.$store.state.paymentMethodsList.refundable.filter(
							(paymentMethod) => paymentMethod.methodName !== 'xsolla-apple'
					  );
			}
			return [];
		},
		nxPrepaidList() {
			if (this.$store.state.paymentMethodsList && this.$store.state.paymentMethodsList.nonrefundable) {
				return this.$store.state.paymentMethodsList.nonrefundable;
			}
			return [];
		},
		isEUCountry() {
			return this.$store.state.isEUCountry;
		},
		pgCategories() {
			// it will be used only for TH to display the payment methods categories
			const pgs = [...this.nxCreditList, ...this.nxPrepaidList];

			if (this.showCategories) {
				let categories = {};

				pgs.forEach((pg) => {
					if (categories[pg.categoryName]) categories[pg.categoryName].paymentMethods.push(pg);
					else
						this.$set(categories, pg.categoryName, {
							displayName: pg.categoryDisplayName,
							paymentMethods: [pg],
						});
				});

				return categories;
			}

			return pgs;
		},
	},
	methods: {
		handleSelectPG(pgDetails) {
			if (pgDetails.status === 'active') {
				this.$emit('click-pg', pgDetails);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.payment-methods-wrapper {
	display: flex;
	flex-wrap: wrap;
	margin-left: -5px;
	margin-right: -5px;
	.payment-methods {
		flex: 0 0 100%;
		max-width: 100%;
		display: flex;
		flex-wrap: wrap;
		.pg-btn-holder {
			flex: 0 0 50%;
			max-width: 50%;
		}
		&__category {
			display: flex;
			flex-wrap: wrap;
			flex: 0 0 100%;
			max-width: 100%;

			&__title {
				font-size: 18px;
				color: #fff;
				flex: 0 0 100%;
				max-width: 100%;
				padding-left: 5px;
				padding-right: 5px;
				padding-top: 12px;
				padding-bottom: 2px;
			}
			&:first-child {
				.payment-methods__category__title {
					padding-top: 0px;
				}
			}
		}
	}
	.payment-message-law {
		font-size: 12px;
		text-align: center;
		line-height: 1.2;
		margin-top: 10px;
		padding-left: 0px;
		padding-right: 0px;
	}
}

@media (max-width: 599px) {
	.payment-methods-wrapper {
		margin-left: 0;
		margin-right: 0;
		.payment-methods {
			.pg-btn-holder {
				flex: 0 0 100%;
				max-width: 100%;
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
}
</style>
